import React from 'react';
const allBonuses = [{
  src: 'https://cdn.magicpatterns.com/uploads/nrUou2xQp8cjdgjAgVzBr4/Copia_de_Celebrate_Shopify_-_Square_(22).png',
  alt: 'Bonus 1: 240 Coloring Books'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1Uo2ZVaKAEKm7hRJpX75TF/Copia_de_Celebrate_Shopify_-_Square_(23).png',
  alt: 'Bonus 2: 130 Box Templates'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3r7CfMQRnVeaVsQhvbVqq9/Copia_de_Celebrate_Shopify_-_Square_(24).png',
  alt: 'Bonus 3: +1,000 Designs for Sublimation'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7zgsdm5XAjiJEUZeb3hD9h/Copia_de_Celebrate_Shopify_-_Square_(25).png',
  alt: 'Bonus 4: 1,200 Cake Toppers'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4qTD4S7c6CTtVneYrCMXGV/Copia_de_Celebrate_Shopify_-_Square_(26).png',
  alt: 'Bonus 5: 5 Birthday Chalkboards'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/v13Q8ZXsrAvBSfgAwYKQa8/Copia_de_Celebrate_Shopify_-_Square_(27).png',
  alt: 'Bonus 6: +250 Digital Invitations'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kAA7JbYGQiQnNU8UPoiwi8/Copia_de_Celebrate_Shopify_-_Square_(28).png',
  alt: 'Bonus 7: 900 School Labels'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wHgNPbWYFDk1NsWDx1Edsa/Copia_de_Celebrate_Shopify_-_Square_(29).png',
  alt: 'Bonus 8: 12 Paper Flower Styles'
}];
export function BonusSection() {
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-light-pink" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <h2 className="text-4xl md:text-6xl font-bold text-magenta mb-6 drop-shadow-sm" data-id="element-17">
            🎁 BUT THAT'S NOT ALL…
          </h2>
          <p className="text-xl md:text-2xl font-bold text-teal-600 bg-white inline-block px-8 py-4 rounded-full shadow-sm border-2 border-teal-100" data-id="element-18">
            Today, when you get the Magic Party Kit, you also receive these{' '}
            <span className="text-magenta" data-id="element-19">8 EXCLUSIVE BONUSES</span> — at no
            extra cost:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-20">
          {allBonuses.map((bonus, index) => <div key={index} className="rounded-2xl overflow-hidden shadow-sm border-2 border-pink-100 relative group hover:border-pink-300 hover:shadow-md transition-all duration-300" data-id="element-21">
              <div className="absolute top-0 right-0 bg-teal-400 text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-22">
                BONUS {index + 1}
              </div>
              <img src={bonus.src} alt={bonus.alt} className="w-full h-full object-cover aspect-square" data-id="element-23" />
            </div>)}
        </div>
      </div>
    </section>;
}